<template>
  <div class="row justify-content-center">
    <div class="col-md-12 col-xl-8">
      <div class="px-xl-4 pt-xl-3">
        <div class="alert alert-primary" v-if="result !== null">
          <i class="fa fa-thumbs-up"></i> {{ result }}
        </div>
        <form
          role="form"
          id="registerForm"
          ref="registerForm"
          @submit="validateForm"
        >
          <h6
            class="heading-small text-muted mb-2 text-uppercase font-montserrat"
          >
            {{ variables.get("user-information") }}
          </h6>
          <div class="row">
            <div class="col-lg-6">
              <base-input
                :disabled="loading"
                class="input-group-alternative mb-3"
                :placeholder="[[variables.get('name')]]"
                addon-left-icon="ni ni-single-02"
                v-model="model.first_name"
              ></base-input>
              <div
                class="alert alert-danger"
                v-for="(error, index) in validationErrors.first_name"
                :key="index"
              >
                * {{ error }}
              </div>
            </div>
            <div class="col-lg-6">
              <base-input
                :disabled="loading"
                class="input-group-alternative mb-3"
                :placeholder="[[variables.get('surname')]]"
                addon-left-icon="ni ni-single-02"
                v-model="model.last_name"
              ></base-input>
              <div
                class="alert alert-danger"
                v-for="(error, index) in validationErrors.last_name"
                :key="index"
              >
                * {{ error }}
              </div>
            </div>
            <div class="col-lg-12">
              <div class="alert register-alert">
                <small class="font-weight-bold font-montserrat">
                  {{ variables.get("registerMailWarn") }}
                </small>
              </div>
              <base-input
                :disabled="loading"
                class="input-group-alternative mb-3"
                :placeholder="[[variables.get('email')]]"
                addon-left-icon="ni ni-email-83"
                type="email"
                v-model="model.email"
              ></base-input>
              <div
                class="alert alert-danger"
                v-for="(error, index) in validationErrors.email"
                :key="index"
              >
                * {{ error }}
              </div>
            </div>
            <div class="col-lg-6">
              <password
                :disabled="loading"
                :placeholder="[[variables.get('password')]]"
                v-model="model.password"
                :show-password="false"
                :badge="false"
                :toggle="true"
              />
            </div>
            <div class="col-lg-6">
              <password
                :disabled="loading"
                :placeholder="[[variables.get('re-password')]]"
                v-model="model.password_confirmation"
                :show-password="false"
                :badge="false"
                :toggle="true"
              />
            </div>
            <div class="col-lg-12">
              <div
                class="alert alert-danger font-montserrat"
                v-for="(error, index) in validationErrors.password"
                :key="index"
              >
                * {{ error }}
              </div>
            </div>
          </div>
          <h6
            class="
              heading-small
              text-muted
              mt-3
              mb-1
              text-uppercase
              font-montserrat
            "
          >
            {{ variables.get("company-information") }}
          </h6>
          <div class="row">
            <div class="col">
              <base-input
                class="input-group-alternative"
                :disabled="loading"
                :placeholder="[[variables.get('company-name')]]"
                addon-left-icon="ni ni-building"
                v-model="model.name"></base-input>
              <div
                class="alert alert-danger"
                v-for="(error, index) in validationErrors.name"
                :key="index">
                * {{ error }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <template>
                <vue-recaptcha
                  ref="recaptcha"
                  @verify="markRecaptchaAsVerified"
                  :sitekey="site_key"></vue-recaptcha>
              </template>
              <div
                class="alert alert-danger"
                v-if="captchaCode.pleaseTickRecaptchaMessage">
                {{ captchaCode.pleaseTickRecaptchaMessage }}
              </div>
            </div>
            <div class="col-12 pt-3">
              <base-checkbox v-model="model.kvkk" :disabled="loading">
                <span class="text-muted font-montserrat register-checkbox">
                  <a
                    href="https://vizyonergenc.com/sozlesme/kvkk-sozlesmesi"
                    target="_blank"
                    class="font-montserrat text-vg-blue">{{ variables.get("kvkk") }}</a>{{ variables.get("acceptKvkk") }}
                </span>
              </base-checkbox>
              <div
                class="alert alert-danger mt-1"
                v-for="(error, index) in validationErrors.kvkk"
                :key="index">
                * {{ error }}
              </div>
            </div>
            <div class="col-12">
              <base-checkbox
                v-model="model.hizmet_sozlesmesi"
                :disabled="loading">
                <span class="text-muted font-montserrat">
                  <a
                    href="https://vizyonergenc.com/sozlesme/hizmet-sozlesmesi"
                    target="_blank"
                    class="font-montserrat text-vg-blue">{{ variables.get("serviceAgreement") }}</a>{{ variables.get("serviceAgreementAccept") }}
                </span>
              </base-checkbox>
              <div
                class="alert alert-danger mt-1"
                v-for="(error, index) in validationErrors.hizmet_sozlesmesi"
                :key="index">
                * {{ error }}
              </div>
            </div>
            <div class="col-12">
              <base-checkbox
                v-model="responsibility_contract"
                :disabled="loading">
                <span class="text-muted font-montserrat">
                  {{ variables.get("responsibility_contract") }}
                </span>
              </base-checkbox>
              <div
                class="alert alert-danger mt-1"
                v-for="(error, index) in validationErrors.responsibility_contract"
                :key="index">
                * {{ error }}
              </div>
            </div>
            <div class="col-12">
              <base-checkbox
                v-model="model.communication_contract"
                :disabled="loading">
                <span class="text-muted font-montserrat">{{variables.get("acceptMailSend")}}</span>
              </base-checkbox>
            </div>
          </div>
          <div class="text-right">
            <base-button
              type="button"
              id="submit"
              native-type="submit"
              class="btn bg-vg-green text-white w-100 mt-3"
              :class="{ 'border-0': loading }"
              v-loading="loading"
              :disabled="loading || !responsibility_contract">
              {{ variables.get("register") }}
            </base-button>
            <p class="text-center mb-0">
              <small class="text-grey font-montserrat">Kayıtlı Mısınız?</small>
              <router-link to="/login">
                <small class="text-vg-blue font-montserrat font-weight-bold">
                  {{ variables.get("login") }}
                </small>
              </router-link>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { variables } from "../langs/tr";
import Password from "vue-password-strength-meter";
import * as axios from "axios";
import { env } from "@/environments/env";
import VueRecaptcha from "vue-recaptcha";

export default {
  components: { Password, VueRecaptcha },
  name: "register",
  data() {
    return {
      site_key: env.SITE_KEY,
      captchaCode: {
        recaptchaVerified: false,
        pleaseTickRecaptchaMessage: "",
      },
      loading: false,
      variables,
      validationErrors: {
        first_name: [],
        last_name: [],
        email: [],
        password: [],
        name: [],
        kvkk: [],
        hizmet_sozlesmesi: [],
        communication_contract: [],
        responsibility_contract: []
      },
      model: {
        captcha_data: "",
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password_confirmation: "",
        name: "",
        kvkk: false,
        hizmet_sozlesmesi: false,
        communication_contract: false
      },
      responsibility_contract: false,
      result: null,
    };
  },
  methods: {
    markRecaptchaAsVerified(response) {
      this.model.captcha_data = response;
      this.captchaCode.pleaseTickRecaptchaMessage = "";
      this.captchaCode.recaptchaVerified = true;
    },
    validateForm: function (e) {
      this.validationErrors = {
        first_name: [],
        last_name: [],
        email: [],
        password: [],
        name: [],
        kvkk: [],
        hizmet_sozlesmesi: [],
        communication_contract: [],
        responsibility_contract: []
      };
      if (!this.captchaCode.recaptchaVerified) {
        this.captchaCode.pleaseTickRecaptchaMessage =
          "* Lütfen robot doğrulama işlemini yapınız.";
      }
      if (this.model.kvkk === false) {
        this.validationErrors.kvkk.push(
          "KVKK kabul etmeden kayıt oluşturamazsınız."
        );
      }
      if (this.model.hizmet_sozlesmesi === false) {
        this.validationErrors.hizmet_sozlesmesi.push(
          "Hizmet sözleşmesini kabul etmeden kayıt oluşturamazsınız."
        );
      }
      if (this.responsibility_contract === false) {
        this.validationErrors.hizmet_sozlesmesi.push(
          "Sorumluluk bildirimini kabul etmeden kayıt oluşturamazsınız."
        );
      }
      if (!this.model.first_name) {
        this.validationErrors.first_name.push("Ad gereklidir.");
      }
      if (!this.model.last_name) {
        this.validationErrors.last_name.push("Soyad gereklidir.");
      }
      if (!this.model.email) {
        this.validationErrors.email.push("E-posta adresi gereklidir.");
      }
      if (!this.model.password) {
        this.validationErrors.password.push("Şifre gereklidir.");
      }
      if (this.model.password && !this.model.password_confirmation) {
        this.validationErrors.password.push("Şifre tekrar gereklidir.");
      }
      if (this.model.password !== this.model.password_confirmation) {
        this.validationErrors.password.push("Şifreler uyuşmuyor.");
      }
      if (!this.model.name) {
        this.validationErrors.name.push("Firma adı gereklidir.");
      }
      if (this.model.email && !this.validEmail(this.model.email)) {
        this.validationErrors.email.push("Hatalı e-posta adresi!");
      }
      if (
        this.validationErrors.first_name.length === 0 &&
        this.validationErrors.last_name.length === 0 &&
        this.validationErrors.email.length === 0 &&
        this.validationErrors.password.length === 0 &&
        this.validationErrors.name.length === 0 &&
        this.validationErrors.kvkk.length === 0 &&
        this.validationErrors.hizmet_sozlesmesi.length === 0 &&
        this.validationErrors.responsibility_contract.length === 0 &&
        this.captchaCode.recaptchaVerified
      ) {
        this.register();
      }
      e.preventDefault();
    },
    validEmail: function (email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    register() {
      this.loading = true;
      axios
        .post(env.API_URL + "company/register", this.model)
        .then((response) => {
          if (response.status === 201) {
            this.result = response.data[0];
            document.getElementById("submit").hidden = true;
          }
          this.loading = false;
        })
        .catch((error) => {
          this.result = error.response.data.messages[0];
          this.loading = false;
          this.$refs.recaptcha.reset();
        });
    },
  },
};
</script>
<style>
.alert {
  padding: 0.5rem 1rem;
}
</style>
